import {NewsListBoxComponent} from './components/news-list-box.component';
import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {FormsModule} from '@angular/forms';

import {SharedModule} from '../../shared/shared.module';
import {NewsListComponent} from './pages/news-list/news-list.page';
import {NewsDetailComponent} from './pages/news-detail/news-detail.page';
import {NewsHttpService} from './services/news-http.service';
import {BDSharedModule} from '@brother-apps/brother-dealerapp-shared-lib';
import {INewsHttpService} from './services/news-http.interface';

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        FormsModule,
        SharedModule,
        BDSharedModule,
        // NewsRoutingModule,
    ],
    declarations: [
        NewsListComponent,
        NewsDetailComponent,
        NewsListBoxComponent


    ],
    exports: [
        NewsListBoxComponent
    ],

    providers: [
        {provide: INewsHttpService, useClass: NewsHttpService}
    ]
})
export class NewsModule {
}
